import {
    FETCH_USERS_INIT_ACTION,
    FETCH_USERS_SUCCESS_ACTION,
  } from "./action";
  
  const initialState = {
    processing: false,
    error: false
  };
  
  export default function(state = initialState, action) {
    switch (action.type) {
        case FETCH_USERS_INIT_ACTION:
        return {
            ...state,
            processing:true
        };

        case FETCH_USERS_SUCCESS_ACTION:
        return {
            ...state,
            processing:false,
            usersList: action.payload.rows,
            usersCount: action.payload.count
        };
  
        default:
        return {
            ...state
        };
    }
}  